import { Observable } from 'rxjs';
import { Component, HostBinding } from '@angular/core';

import { LoadingStateService } from '@frontend-site/shared/core';
import { tap } from 'rxjs/operators';

/**
 * Shows a blocking loading animation when the app is busy.
 * Busy state is determined by {@link LoadingStateService}.
 *
 * @export
 * @class PLoadingComponent
 */
@Component({
    selector: 'p-loading',
    template: `<pui-spinner *ngIf="isLoading$ | async"></pui-spinner>`,
    styleUrls: ['./p-loading.component.scss']
})
export class PLoadingComponent {
    @HostBinding('class.p-spinner-shown') isLoading = false;

    public readonly isLoading$: Observable<boolean>;

    constructor(public readonly loadingStateService: LoadingStateService) {
        this.isLoading$ = loadingStateService.isLoading$.pipe(
            tap((isLoadingFromStateService) => {
                setTimeout(() => {
                    this.isLoading = isLoadingFromStateService;
                });
            })
        );
    }
}
